import { FormBuilder } from "@/components/form-builder"
import { HeaderForm } from "@/components/header-form"
import { SimpleAccordion } from "@/components/ui/simple-accordion"
import { FormActions } from "../components/person-steps/form-actions"
import { usePersonPFAdd } from "../hooks/use-person-pf-add"

interface PersonPFAddViewProps {
  onContinue: () => void
  onBack: () => void
}

export function PersonPFAddView({ onContinue, onBack }: PersonPFAddViewProps) {
  const {
    form,
    isPending,
    onFormSubmit,
    personalInfoFields,
    addressFields,
    healthFields,
    bankFields,
  } = usePersonPFAdd({ onSuccess: onContinue })

  const accordionItems = [
    {
      id: "personal",
      title: <HeaderForm title="DADOS PESSOAIS" />,
      content: (
        <FormBuilder
          fields={personalInfoFields}
          layout={{ columns: 2, gap: "md" }}
          formInstance={form}
          onSubmit={async () => undefined}
          showSave={false}
        />
      ),
    },
    {
      id: "address",
      title: <HeaderForm title="ENDEREÇO" />,
      content: (
        <FormBuilder
          fields={addressFields}
          layout={{ columns: 2, gap: "md" }}
          formInstance={form}
          onSubmit={async () => undefined}
          showSave={false}
        />
      ),
    },
    {
      id: "health",
      title: <HeaderForm title="SAÚDE E PREVENÇÃO" />,
      content: (
        <FormBuilder
          fields={healthFields}
          layout={{ columns: 2, gap: "md" }}
          formInstance={form}
          onSubmit={async () => undefined}
          showSave={false}
        />
      ),
    },
    {
      id: "bank",
      title: <HeaderForm title="DADOS BANCÁRIOS" />,
      content: (
        <FormBuilder
          fields={bankFields}
          layout={{ columns: 2, gap: "md" }}
          formInstance={form}
          onSubmit={async () => undefined}
          showSave={false}
        />
      ),
    },
  ]

  return (
    <div className="space-y-8">
      <SimpleAccordion
        className="bg-darkblue rounded-lg p-8"
        itemClassName="border-none"
        items={accordionItems}
      />

      <FormActions
        isPending={isPending}
        onBack={onBack}
        onSubmit={() => onFormSubmit(form.getValues())}
      />
    </div>
  )
}
